import { useRef, useState } from 'react';
import {
    IonButtons,
    IonButton,
    IonHeader,
    IonContent,
    IonToolbar,
    IonTitle,
    IonPage,
    IonItem,
    IonLabel,
    IonInput,
    useIonAlert,
    IonFooter,
    IonGrid,
    IonRow,
    IonCol,
    IonSelect,
    IonSelectOption,
    IonCheckbox,
    IonIcon
} from '@ionic/react';
import { addResource, deleteResource, getResources, setResource } from '../firebase/resources';
import { getCurrentUserUID } from '../firebase/firebase';
import { getSmsTemplates } from '../firebase/smsTemplates';
import { CirclePicker } from 'react-color';
import Swatches from 'react-color/lib/components/swatches/Swatches';
import Compact from 'react-color/lib/components/compact/Compact';
import Slider from 'react-color/lib/components/slider/Slider';
import Twitter from 'react-color/lib/components/twitter/Twitter';
import Circle from 'react-color/lib/components/circle/Circle';
import { createUserAccount, deleteUser, getUsers, setUser } from '../firebase/users';
import { checkmark, chevronBack } from 'ionicons/icons';
import { getDocumentTemplates } from '../firebase/documentTemplates';

const UserEditor = ({
    onDismiss,
    user
}: {
    onDismiss: () => void,
    user: any
}) => {

    const [presentAlert] = useIonAlert();


    const [email, setEmail] = useState(user.email ?? "");
    const [password, setPassword] = useState("");

    const [name, setName] = useState(user.name ?? "");
    const [surname, setSurName] = useState(user.surname ?? "");
    const [initials, setInitials] = useState(user.initials ?? "");
    const [role, setRole] = useState(user.role ?? "");
    const [baseRate, setBaseRate] = useState<number>(Number.isInteger(user.baseRate) ? user.baseRate : 0);
    const [percentageRate, setPercentageRate] = useState<number>(Number.isInteger(user.percentageRate) ? user.percentageRate : 0);
    const [individualRate, setIndividualRate] = useState<number>(Number.isInteger(user.individualRate) ? user.individualRate : 0);
    const [resources, setResources] = useState(user.resources ?? []);
    const [smsTemplates, setSmsTemplates] = useState(user.smsTemplates ?? []);
    const [sms, setSms] = useState(user.sms ?? false);
    const [clientsPanel, setClientsPanel] = useState(user.clientsPanel ?? true);
    const [birthdaysPanel, setBirthdaysPanel] = useState(user.birthdaysPanel ?? user.clientsPanel ?? true);
    const [smsPanel, setSmsPanel] = useState(user.smsPanel ?? false);
    const [documentTemplates, setDocumentTemplates] = useState(user.documentTemplates ?? []);
    const [clientAccess, setClientAccess] = useState(user.clientAccess ?? []);
    const [onlyOwnEvents, setOnlyOwnEvents] = useState(user.onlyOwnEvents ?? false);


    const [color, setColor] = useState(user.color ?? "#0000FF");


    const isNew = user.id === undefined;

    function confirm() {
        //update or create
        const data = { email: email, name: name, surname: surname, initials: initials, role: role, baseRate: baseRate, percentageRate: percentageRate, individualRate: individualRate, resources: resources, smsTemplates: smsTemplates, sms: sms, color: color, clientsPanel: clientsPanel, birthdaysPanel: birthdaysPanel, smsPanel: smsPanel, documentTemplates: documentTemplates, clientAccess: clientAccess, onlyOwnEvents: onlyOwnEvents, enabled:true };
        if (isNew) {
            createUserAccount(data, password, (added: boolean) => {
                if (added) {
                    onDismiss();
                }
            })
        } else {
            setUser(data, user.id, (update: boolean) => {
                onDismiss();
            })
        }

    }



    function remove() {
        presentAlert({
            header: 'Usuwanie!',
            buttons: [
                {
                    text: 'Anuluj',
                    role: 'cancel'
                },
                {
                    text: 'Usuń',
                    role: 'confirm',
                },
            ],
            onDidDismiss: (e: CustomEvent) => {
                if (e.detail.role === 'confirm') {
                    deleteUser(user.id);
                    onDismiss();
                }
            },
        })

    }

    function cancel() {
        onDismiss();
    }

    const roles = [{ key: 'manager', value: "menadżer" }, { key: 'reception', value: "recepcja" }, { key: 'user', value: "użytkownik" }]
    const resourcesList = getResources();
    const smsTemplatesList = getSmsTemplates(true);
    const documentTemplatesList = getDocumentTemplates(true);
    const userList = getUsers();


    //console.log("clientAccess", clientAccess);
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="medium" onClick={() => cancel()}>
                            <IonIcon icon={chevronBack} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle>{isNew ? "Tworzenie użytkownika" : "Edycja użytkownia " + name + " " + surname}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={() => confirm()}> <IonIcon icon={checkmark} /></IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent style={{ height: '100%' }} className="ion-padding">
                <IonItem>
                    <IonLabel>email</IonLabel>
                    <IonInput style={{ maxWidth: "70%" }} slot="end" disabled={!isNew} placeholder="email" onIonChange={(e) => setEmail(e.detail.value)} value={email} ></IonInput>
                </IonItem>
                <IonItem hidden={!isNew} >
                    <IonLabel >hasło</IonLabel>
                    <IonInput style={{ maxWidth: "70%" }} slot="end" placeholder="hasło" type="password" onIonChange={(e) => setPassword(e.detail.value ?? '')} value={password} ></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel >imię</IonLabel>
                    <IonInput style={{ maxWidth: "70%" }} slot="end" placeholder="imię" onIonChange={(e) => setName(e.detail.value)} value={name} ></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel >nazwisko</IonLabel>
                    <IonInput style={{ maxWidth: "70%" }} slot="end" placeholder="nazwisko" onIonChange={(e) => setSurName(e.detail.value)} value={surname} ></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel >inicjały</IonLabel>
                    <IonInput style={{ maxWidth: "70%" }} slot="end" placeholder="inicjaly" onIonChange={(e) => setInitials(e.detail.value)} value={initials}  ></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel>stawka podstawowa</IonLabel>
                    <IonInput
                        style={{ maxWidth: "70%" }}
                        slot="end"
                        type="number"
                        inputmode="numeric"
                        step="1"
                        placeholder="stawka podstawowa"
                        onIonChange={(e) => {
                            const value = e.detail.value ?? "";
                            const parsed = parseInt(value, 10);
                            setBaseRate(Number.isNaN(parsed) ? 0 : parsed);
                        }}
                        value={baseRate}
                    ></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel>stawka procentowa</IonLabel>
                    <IonInput
                        style={{ maxWidth: "70%" }}
                        slot="end"
                        type="number"
                        inputmode="numeric"
                        step="1"
                        placeholder="stawka procentowa"
                        onIonChange={(e) => {
                            const value = e.detail.value ?? "";
                            const parsed = parseInt(value, 10);
                            setPercentageRate(Number.isNaN(parsed) ? 0 : parsed);
                        }}
                        value={percentageRate}
                    ></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel>stawka indywidualna</IonLabel>
                    <IonInput
                        style={{ maxWidth: "70%" }}
                        slot="end"
                        type="number"
                        inputmode="numeric"
                        step="1"
                        placeholder="stawka indywidualna"
                        onIonChange={(e) => {
                            const value = e.detail.value ?? "";
                            const parsed = parseInt(value, 10);
                            setIndividualRate(Number.isNaN(parsed) ? 0 : parsed);
                        }}
                        value={individualRate}
                    ></IonInput>
                </IonItem>
                <div style={{ padding: "10px", margin: "0px 20px" }}>
                    <Circle color={color} onChangeComplete={(e) => setColor(e.hex)} />
                </div>
                <IonItem>
                    <IonLabel>uprawnienia</IonLabel>
                    <IonSelect slot="end" disabled={!isNew && getCurrentUserUID() === user.id} interface="popover" onIonChange={(e) => setRole(e.detail.value)} value={role} placeholder="uprawnienia">
                        {roles.map(item => {
                            return <IonSelectOption style={{ backgroundColor: "yellow" }} key={item.key} value={item.key}>{item.value}</IonSelectOption>
                        })}
                    </IonSelect>
                </IonItem>
                <IonItem>
                    <IonLabel>pokoje</IonLabel>
                    <IonSelect style={{ maxWidth: "70%" }} slot="end" interface="popover" onIonChange={(e) => setResources(e.detail.value)} value={resources} placeholder="uprawnienia" multiple={true}>
                        {resourcesList.map(item => {
                            return <IonSelectOption key={item.resourceId} value={item.resourceId}>{item.resourceTitle}</IonSelectOption>
                        })}
                    </IonSelect>
                </IonItem>
                <IonItem>
                    <IonLabel>SMS wydarzenia</IonLabel>
                    <IonCheckbox slot="end" onIonChange={(e) => setSms(e.detail.checked)} checked={sms}></IonCheckbox>
                </IonItem>
                <IonItem>
                    <IonLabel>lista pacjentów</IonLabel>
                    <IonCheckbox slot="end" onIonChange={(e) => setClientsPanel(e.detail.checked)} checked={clientsPanel}></IonCheckbox>
                </IonItem>
                <IonItem>
                    <IonLabel>urodziny</IonLabel>
                    <IonCheckbox slot="end" onIonChange={(e) => setBirthdaysPanel(e.detail.checked)} checked={birthdaysPanel}></IonCheckbox>
                </IonItem>
                <IonItem>
                    <IonLabel>SMS panel</IonLabel>
                    <IonCheckbox slot="end" onIonChange={(e) => setSmsPanel(e.detail.checked)} checked={smsPanel}></IonCheckbox>
                </IonItem>
                <IonItem>
                    <IonLabel>szablony SMS</IonLabel>
                    <IonSelect style={{ maxWidth: "70%" }} slot="end" interface="popover" onIonChange={(e) => setSmsTemplates(e.detail.value)} value={smsTemplates} placeholder="schematy SMS" multiple={true}>
                        {smsTemplatesList.map(item => {
                            return <IonSelectOption key={item.id} value={item.id}>{item.topic}</IonSelectOption>
                        })}
                    </IonSelect>
                </IonItem>
                <IonItem>
                    <IonLabel>szablony dokumentów</IonLabel>
                    <IonSelect style={{ maxWidth: "70%" }} slot="end" interface="popover" onIonChange={(e) => setDocumentTemplates(e.detail.value)} value={documentTemplates} placeholder="schematy dokumentów" multiple={true}>
                        {documentTemplatesList.map(item => {
                            return <IonSelectOption key={item.id} value={item.id}>{item.topic}</IonSelectOption>
                        })}
                    </IonSelect>
                </IonItem>
                <IonItem>
                    <IonLabel>pacjenci</IonLabel>
                    <IonSelect style={{ maxWidth: "70%" }} slot="end" interface="popover" onIonChange={(e) => setClientAccess(e.detail.value)} value={clientAccess} placeholder="pacjenci" multiple={true}>
                        
                        {userList.map(item => {
                            if (item.id !== user.id && item.enabled || clientAccess[item.id]!==undefined) {
                                //console.log(item.id, clientAccess[item.id]);
                                return <IonSelectOption key={item.id} value={item.id}>{item.name} {item.surname}</IonSelectOption>
                            }
                        })}
                    </IonSelect>
                </IonItem>
                <IonItem>
                    <IonLabel>tylko własne wydarzenia</IonLabel>
                    <IonCheckbox slot="end" onIonChange={(e) => setOnlyOwnEvents(e.detail.checked)} checked={onlyOwnEvents}></IonCheckbox>
                </IonItem>


            </IonContent>
            <IonFooter>
                {!isNew && name === "" && surname === "" ? <div><IonButton size="small" color="danger" onClick={() => remove()}>usuń</IonButton> <br /><br /></div> : ""}
            </IonFooter>
        </IonPage>
    );
};

export default UserEditor;

